class UserAgentHelper {
    static IsMobile() {
        // https://stackoverflow.com/a/24600597/9373938
        return /Mobi|Android/i.test(navigator.userAgent);
    }
}

export default UserAgentHelper;